import {
  isValidReference,
  type ObjectType,
  TaskCode,
} from '@quromedical/fhir-common';
import * as yup from 'yup';

import type {
  CreateTaskAssignment,
  TaskAssignment,
  TaskStatus,
  TaskUpdateStatusRequest,
} from './schema';

const statuses: TaskStatus[] = [
  'draft',
  'requested',
  'received',
  'accepted',
  'rejected',
  'ready',
  'cancelled',
  'in-progress',
  'on-hold',
  'failed',
  'completed',
  'entered-in-error',
];

export const updateTaskStatusSchema = yup.object<
  ObjectType<TaskUpdateStatusRequest>
>({
  note: yup.string().required(),
  status: yup.string().equals(statuses).required(),
});

const optionalReferenceSchema = yup
  .object()
  .default(undefined)
  .test({
    name: 'is-value-reference',
    message: (d) => `${d.path} is not a valid reference`,
    test: (value) => (value ? isValidReference(value) : true),
  });

const requiredReferenceSchema = yup.object().test({
  name: 'is-value-reference',
  message: (d) => `${d.path} is not a valid reference`,
  test: isValidReference,
});

export const assignTaskSchema = yup.object<ObjectType<TaskAssignment>>({
  code: yup.string().required().equals(Object.values(TaskCode)),
  description: yup.string().required(),
  performer: requiredReferenceSchema,
  requestedPeriodEnd: yup.string().optional(),
});

export const createTaskAssignmentSchema = yup.object<
  ObjectType<CreateTaskAssignment>
>({
  ...assignTaskSchema.fields,
  focus: optionalReferenceSchema,
});
